import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ControlsModule } from 'src/app/controls/controls.module';
import { CourseService } from 'src/app/core/course.service';
import { Course } from 'src/app/models/course.model';

@Component({
  selector: 'app-create-course',
  templateUrl: './create-course.component.html',
  styleUrls: ['./create-course.component.scss'],
  imports: [
    CommonModule,
    TranslateModule,
    ControlsModule
  ]
})
export class CreateCourseComponent {
  
  form!: FormGroup;
  isLoading: boolean = false;

  @Output() courseCreationFinished: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private fb: FormBuilder,
    private courseService: CourseService
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(3)]],
      color: ['', [Validators.required]]
    });
  }

  saveCourse() {
    this.form.markAllAsTouched();
    if (!this.form.valid) {
      return;
    }
    this.isLoading = true;
    const course = new Course(
      null,
      this.form.value.name,
      null,
      0,
      this.form.value.color,
      [],
      [],
      0,
      0
    );
    this.courseService.saveCourse(course).subscribe((result) => {
      this.isLoading = false;
      this.courseCreationFinished.emit();
    });
  }

  getControl(control: string) {
    return this.form!.get(control) as FormControl;
  }
}
